/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Premium_Types_SubInputs */

const en_dialog_premium_types_sub = /** @type {(inputs: Dialog_Premium_Types_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free is only PDF and websites`)
};

const es_dialog_premium_types_sub = /** @type {(inputs: Dialog_Premium_Types_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis solo PDF y sitios web`)
};

/**
* | output |
* | --- |
* | "Free is only PDF and websites" |
*
* @param {Dialog_Premium_Types_SubInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_premium_types_sub = /** @type {((inputs?: Dialog_Premium_Types_SubInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Premium_Types_SubInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_premium_types_sub(inputs)
	return en_dialog_premium_types_sub(inputs)
});